const ReceivedOfferStart = ({ nextStep, cost, date, id ,isCounter, days, hours, minutes }) => {

  const formatData = (receivedDate) => {
    const date = new Date(receivedDate);

    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h24'
    }).replace(',', '')
  }

  return (
    <>
      <ul className="sell-card__info-list">
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Amount Offered</span>
          <b className="sell-card__info-list-item-value">${cost.toFixed(2)} USD</b>
        </li>
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Offer Submitted</span>
          <b className="sell-card__info-list-item-value">{formatData(date)}</b>
        </li>
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Transaction id</span>
          <b className="sell-card__info-list-item-value">{id}</b>
        </li>
      </ul>
      <div className="make-offer__form-row make-offer__form-row--double">
        <label>Offer valid for</label>
        <p className="make-offer__input-wrapper">
          <input type="text" name="days" disabled value={days} />
          <span>DAYS</span>
        </p>
        <p className="make-offer__input-wrapper">
          <input type="text" name="hours" disabled value={hours + ':' + minutes} />
          <span>HOURS</span>
        </p>
      </div>
      <p className="make-offer__form-hint">
        The counteroffer is valid until accepted or it expires. Cards may have multiple pending offers, which may be accepted at any time.
        Therefore this counteroffer does not guarantee the right to purchase this card.
      </p>
      <footer className="sell-card__info-offer-options">
        <button className="accept" onClick={() => nextStep('accept')}>Accept</button>
        <button onClick={() => nextStep('decline')}>Decline</button>
        {!isCounter && <button onClick={() => nextStep('counter')}>Counter</button>}
      </footer>
    </>
  )
}

export default ReceivedOfferStart;
